import { useTranslation } from "react-i18next";
import { UnavailableIcon } from "@/shared/ui/icons/unavailable-icon";

export default function SplitPaymentUnavailable() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col  gap-4 rounded-[14px] border-[0.5px] border-[#DAE0EB] bg-[#F4F6F9] px-4 py-3">
      <div className="flex items-center gap-3">
        <UnavailableIcon />
        <span
          className="text-xs  leading-4"
          style={{
            color: "var(--Content-Low, #7E82AD)",
            letterSpacing: "-0.18px",
          }}
        >
          {t("plan.split_payment_unavailable")}
        </span>
      </div>
    </div>
  );
}
